"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    error: {
      color: "#D5190C !important"
    }
  };
};

exports.styles = styles;